(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const applyHeroCopy = () => {
    const headingCopy = 'Precision Peptides.<br/>Elevated Research.';
    const supportCopy = 'Independent testing. Transparent results.<br/>Research use only.';

    document.querySelectorAll('.hero .slide__content .text-block.h1').forEach((block) => {
      const target = block.querySelector('p, h1, h2') || block;
      target.innerHTML = headingCopy;
    });

    document.querySelectorAll('.hero .slide__content .text-block.paragraph').forEach((block) => {
      const target = block.querySelector('p') || block;
      target.innerHTML = supportCopy;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeroCopy);
  } else {
    applyHeroCopy();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molecule-welcome"] && !Shopify.designMode) return;
  try {
    
  const bindWelcomeBis = (root) => {
    if (!root || root.dataset.welcomeBound === 'true') return;
    root.dataset.welcomeBound = 'true';

    const dialogComponent = root.querySelector('dialog-component.molecule-welcome-bis');
    const tagsInput = root.querySelector('[data-welcome-tags]');
    const noteInput = root.querySelector('[data-welcome-product-note]');
    const marketingInput = root.querySelector('[data-welcome-marketing]');
    const defaultTags = tagsInput?.value || 'back-in-stock';

    const syncTags = () => {
      if (!tagsInput) return;
      tagsInput.value = marketingInput?.checked ? `${defaultTags},newsletter` : defaultTags;
    };

    marketingInput?.addEventListener('change', syncTags);

    const openDialog = (productTitle) => {
      if (noteInput && productTitle) noteInput.value = productTitle;
      dialogComponent?.showDialog();
    };

    root.querySelectorAll('[data-welcome-bis-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => openDialog(trigger.dataset.productTitle || ''));
    });

    if (dialogComponent?.dataset.openOnLoad === 'true') {
      customElements.whenDefined('dialog-component').then(() => dialogComponent.showDialog());
    }
  };

  document.querySelectorAll('.molecule-welcome').forEach(bindWelcomeBis);

  document.addEventListener('shopify:section:load', (event) => {
    bindWelcomeBis(event.target.querySelector('.molecule-welcome'));
  });

  } catch(e) { console.error(e); }
})();
})();
